import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getPurchaseOrderApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const getPurchaseOrderListApi = createAsyncThunk('getPurchaseOrderList', async (payload) => {
  // console.log('payload', payload);
  return await getPurchaseOrderApi(payload);
});

const getPurchaseOrderListSlice = createSlice({
  name: 'getPurchaseOrderList', // Unique Name
  initialState,
  reducers: {
    getPurchaseOrderListReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPurchaseOrderListApi.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(getPurchaseOrderListApi.fulfilled, (state, action) => {
        const { message = '', data = [], payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(getPurchaseOrderListApi.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { getPurchaseOrderListReset } = getPurchaseOrderListSlice.actions;

export default getPurchaseOrderListSlice.reducer;
